import { render, staticRenderFns } from "./ProfileNotifications.view.vue?vue&type=template&id=6c7f0b4b&"
import script from "./ProfileNotifications.view.vue?vue&type=script&lang=js&"
export * from "./ProfileNotifications.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports